import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EnvironmentService} from '../environment.service';
import {Observable} from 'rxjs';
import {IPaymentEstimate} from '../../common/models/interfaces';
import {InfoWidgetResponse} from '../account.service';
import {ApiClient} from './userway-api.service';
import {
  ApiCodeResponse,
  CodeToDevBodyDto,
  GetAccountByEmailResponseDto,
  GetAccountCodeBySiteResponseDto,
  LaunchNoCardTrialSubscriptionDto,
  UserChangeEmailBodyDto,
  UserRegistrationBodyDto,
  UsersSignupCreateData,
  UwV2BillingCartCalculateAutoRenewCreateData,
  UwV2BillingSubscriptionsLaunchNcTrialSubscriptionCreateData,
  UwV2BillingSubscriptionsSubscriptionIdListData,
  WalkthroughStatusType,
} from '../../../userway/sdk/UserWayApiClient';

interface AccountCodeResponse {
  account: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  constructor(
    private env: EnvironmentService,
    private http: HttpClient,
    private apiClient: ApiClient,
  ) {}

  updateWalkthroughStatus(walkthroughStatusType: WalkthroughStatusType) {
    const request = this.apiClient.api.users.usersWalkthroughStatusCreate({walkthroughStatusType});
    return this.apiClient.fetch(request);
  }

  noTrialWelcomeScreenShown() {
    const request = this.apiClient.api.users.usersNcTrialWelcomeScreenShownCreate();
    return this.apiClient.fetch(request);
  }

  checkEmail(email: string): Observable<GetAccountByEmailResponseDto> {
    const request = this.apiClient.api.users.v1UsersAccountByEmailCreate({email});
    return this.apiClient.fetch(request);
  }

  signUp(signUp: UserRegistrationBodyDto): Observable<UsersSignupCreateData> {
    const request = this.apiClient.api.auth.usersSignupCreate(signUp);
    return this.apiClient.fetch(request);
  }

  sendCodeToDev(reqData: CodeToDevBodyDto): Observable<ApiCodeResponse> {
    const request = this.apiClient.api.users.usersCodeToDevCreate(reqData);
    return this.apiClient.fetch(request);
  }

  infoWidget(code: string): Observable<InfoWidgetResponse> {
    const url = `${this.env.apiUrl.apiBase}users/info-widget?code=${code}`;

    return this.http.get<InfoWidgetResponse>(url);
  }

  getAccountIdBySiteId(siteId: number): Observable<GetAccountCodeBySiteResponseDto> {
    const request = this.apiClient.api.users.v1UsersAccountCodeBySiteCreate({siteId: siteId.toString()});
    return this.apiClient.fetch(request);
  }

  changeEmail(reqData: UserChangeEmailBodyDto): Observable<ApiCodeResponse> {
    const request = this.apiClient.api.users.usersChangeEmailCreate(reqData);
    return this.apiClient.fetch(request);
  }

  // TODO: swagger-api - add response type when DASH-263 merged
  getSubscriptions(searchDomainValue?: string): Observable<any> {
    const request = this.apiClient.api.stripe.uwV2BillingSubscriptionsList({search: searchDomainValue});
    return this.apiClient.fetch(request);
  }

  getSubscription(subscriptionId: number): Observable<UwV2BillingSubscriptionsSubscriptionIdListData> {
    const request = this.apiClient.api.stripe.uwV2BillingSubscriptionsSubscriptionIdList({
      subscriptionId: String(subscriptionId),
    });
    return this.apiClient.fetch(request);
  }

  getSubscriptionsEstimate(paymentEstimate: IPaymentEstimate): Observable<any> {
    const url = `${this.env.apiUrl.apiBaseV1}users/subscriptions/estimate`;

    return this.http.post(url, paymentEstimate);
  }

  myDomains(id: number): Observable<any> {
    const url = `${this.env.apiUrl.apiBase}users/my_domains/${id}`;

    return this.http.get(url);
  }

  getSubscriptionAutoRenewPrice(subscriptionId: number): Observable<UwV2BillingCartCalculateAutoRenewCreateData> {
    const request = this.apiClient.api.billing.uwV2BillingCartCalculateAutoRenewCreate({subscriptionId});
    return this.apiClient.fetch(request);
  }

  launchNoCardTrial(
    data: LaunchNoCardTrialSubscriptionDto,
  ): Observable<UwV2BillingSubscriptionsLaunchNcTrialSubscriptionCreateData> {
    const request = this.apiClient.api.billing.uwV2BillingSubscriptionsLaunchNcTrialSubscriptionCreate(data);
    return this.apiClient.fetch(request);
  }
}
